// extracted by mini-css-extract-plugin
module.exports = {"item":"ExhibitionItem_item__V4_fV","img":"ExhibitionItem_img__Dog0B","lottie":"ExhibitionItem_lottie__tZgf3"};